import React, { FC } from 'react';
import { SystemManager } from '../../../utils/SystemManager';

const TitularTpec: FC = () => {
  return <>{SystemManager.getSystem('tarjeta-titular-tpec')}</>;
};

export default TitularTpec;
